import { render, staticRenderFns } from "./reservation-checkout-summary.vue?vue&type=template&id=38040f72&scoped=true"
import script from "./reservation-checkout-summary.vue?vue&type=script&lang=js"
export * from "./reservation-checkout-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38040f72",
  null
  
)

export default component.exports